import { useRoutes } from 'react-router-dom';
import CONFIG from './config';
import { IAuth, AuthStatus } from '../store/types/auth';

interface IProps {
  auth: IAuth;
  status: AuthStatus;
}

const Navigation = ({ auth, status }: IProps) => useRoutes(CONFIG.Public.routes(auth, status));

export default Navigation;
